import { useCallback } from 'react';
import { isOk, useToasts } from '@synqo/frontend-component-library';
import { TableModalWithLayoutSettings } from '@Components/Tables/TableModalWithLayoutSettings';
import { userColumns } from '@Constants/TableColumns';
import { type ApiUser, EnumFrontendLayoutSetting } from '@Model';
import { useImportSourceUsers, useImportUser } from './useImportUserApi';

interface ImportUserModalProps {
    isOpen: boolean;
    onClose: () => void;
    onImported: () => void;
}

export function ImportUserModal({ isOpen, onClose, onImported }: ImportUserModalProps) {
    const { pushToast, pushAllToasts } = useToasts();

    const { users } = useImportSourceUsers(isOpen);
    const { mutateAsync: importUser } = useImportUser();

    const handleSelect = useCallback(
        async (user: ApiUser): Promise<boolean> => {
            const result = await importUser(user.id);
            if (!isOk(result)) {
                pushAllToasts(result.messages);
                return false;
            }
            pushToast({
                title: 'Benutzer importiert',
                message: 'Der Benutzer wurde in die aktuelle Partnerschaft importiert.',
                variant: 'success',
            });
            onImported();
            onClose();
            return true;
        },
        [importUser, pushToast, pushAllToasts, onClose, onImported],
    );

    return (
        <TableModalWithLayoutSettings<ApiUser>
            title="Benutzer aus anderer Partnerschaft importieren"
            isOpen={isOpen}
            onClose={onClose}
            layoutSettingsContext={EnumFrontendLayoutSetting.UsersTableLayout}
            tableProps={{
                name: 'ImportUserList',
                columns: userColumns,
                items: users,
                onSelect: handleSelect,
            }}
        />
    );
}
